import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Seo from "../../../common/helpers/seo";

import routing from "../../routing";
import { amazonHost } from "../../paths";

import { StyledSpring, CardHolder, Card } from "./styles";
import messages from "./messages";

const articles = [
    {
        path: `/${routing.help}/${routing.helpRhythmName}`,
        title: messages.rhytNameTitle,
        image: routing.helpRhythmName,
    },
    {
        path: `/${routing.help}/${routing.helpListingProcess}`,
        title: messages.listingTitle,
        image: routing.helpListingProcess,
    },
    {
        path: `/${routing.help}/${routing.helpMeta}`,
        title: messages.metaTitle,
        image: routing.helpMeta,
    },
    {
        path: `/${routing.help}/${routing.helpFilters}`,
        title: messages.filterTitle,
        image: routing.helpFilters,
    },
    {
        path: `/${routing.help}/${routing.helpCovid}`,
        title: messages.distanceTeaching,
        image: routing.helpCovid,
    },
    {
        path: `/${routing.help}/${routing.helpExperience}`,
        title: messages.experience,
        image: routing.helpExperience,
    },
    {
        path: `/${routing.help}/${routing.publishingPolicies}`,
        title: messages.moderation,
        image: routing.publishingPolicies,
    },
]

const Help = () => {
    const { formatMessage } = useIntl()
    return (
        <StyledSpring withShadow marginTop={50}>
            <Seo title={formatMessage(messages.title)} />
            <h1>
                <FormattedMessage {...messages.title} />
            </h1>
            <CardHolder>
                {articles.map(({ title, path, image }) => (
                    <Card to={path}>
                        <h3 title={formatMessage(title)}><FormattedMessage {...title} /></h3>
                        <div className="ImageHolder">
                            <img src={`${amazonHost}help/help_${image}.jpg`} />
                        </div>
                    </Card>
                ))}
            </CardHolder>
        </StyledSpring>
    );
}

export default Help;
